import Vue from 'vue'
import App from './App.vue'
import router from './router/index'
import {Button, Toast, Popup, CountDown, Swipe, SwipeItem, Notify, Icon} from 'vant';
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.min.css'

Vue.use(VueAwesomeSwiper)
Vue.use(Swipe);
Vue.use(Notify);
Vue.use(SwipeItem);
Vue.use(Button)
Vue.use(Popup)
Vue.use(Toast)
Vue.use(CountDown)
Vue.use(Icon)

import './assets/css/reset.css'
import './assets/css/border.css'
import 'lib-flexible'
import './utils/rem'

Vue.config.productionTip = false

import '@/assets/font/font.css'

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
})

new Vue({
    router,
    render: h => h(App),
}).$mount('#app',)
